import Component from '../lib/Component'
import {setCookie, hasCookie} from '../lib/cookieHelpers'

export default class CookiePolicy extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.cookieName = 'cookie_policy_accepted'
    this.html = document.getElementById('global_cookie_policy').innerHTML
    this.bodyElem = document.querySelector('body')
  }

  acceptCookie (e) {
    e.preventDefault()
    setCookie(this.cookieName, 'true', '31')
    this.hidePolicy()
    return false
  }

  showPolicy () {
    this.addClass('_is_open', this.policy)
  }

  hidePolicy () {
    this.removeClass('_is_open', this.policy)
      .addAnimationClass('_is_closed', this.policy)
      .then(() => {
        this.policy.remove()
      })
  }

  init () {
    if (!hasCookie(this.cookieName)) {
      this.bodyElem.insertAdjacentHTML('beforeend', this.html)
      this.policy = this.bodyElem.querySelector('.js-CookiePolicy')
      this.acceptBtn = this.policy.querySelector('.js-CookiePolicy__btn')
      this.acceptBtn.addEventListener('click', this.acceptCookie.bind(this))

      this.showPolicy()
    }
  }
}
